import React from 'react'
import { BuddyTable } from '../../table-helpers/BuddyTable-2';
import { formatBillingMonth, getCommercialData, getIndepData, getUniData } from './helpers';
import { getApexStorage, getModel } from '../common';

function EarningsHistory(props) {
    let model = getModel()
    let apexType = getApexStorage()
    let data = getCommercialData()
    return (
        <>
            <h3 className="bb-sub-header-txt mb-4">{model === 2 ? "Volume Rewards Historical Statements" : "Earnings Statements to deliver Rich Media"}</h3>
            <BuddyTable
                defaultValue={1}
                pagesize={1}
                tableSorting={false}
                showPagination={false}
                showRowtable={false}
                emptyMessage="No Data Found."
                paginateClassName="col-12"
                skeletonloading={false}
                total={1}
                loading={false}
                currentPage={1}
                data={data}
                className="cursor-pointer col-12 buddy_light p-0"
                dataFor="invoices"
                columns={[
                    {
                        Header: "Month",
                        accessor: "month",
                        className: "text-center",
                        minWidth: 100,
                        Cell: ({ row }) => ( formatBillingMonth(row.original["billing month"]))
                    },
                    {
                        Header: "Statement Number",
                        accessor: "statementNumber",
                        className: "text-center",
                        minWidth: 100,
                    },
                    {
                        Header: "Amount",
                        accessor: apexType === "independent" ? "valueAfterFee" : "totalFee" ,
                        className: "text-center",
                        minWidth: 70,
                        Cell: ({ row }) => <span>${apexType === "independent" ? row.original.valueAfterFee : row.original.totalFee}</span>

                    },
                    {
                        Header: "PDF",
                        accessor: "pdf",
                        className: "text-center",
                        minWidth: 100,
                        Cell: ({ row }) => <a style={{color: "black"}} href="#" target="_blank" rel="noreferrer">
                            <i className="fas fa-file-pdf"></i>
                          </a> 

                    }
                ]}
            /> 

        </>
    )
}

export default (EarningsHistory);
